import { DEFAULT_PUZZLE_VOICE } from '../constants/puzzles.js';
const TACTIC_LABELS = [
    ['fork', 'Fork'],
    ['skewer', 'Skewer'],
    ['pin', 'Pin'],
    ['discoveredAttack', 'Discovered Attack'],
    ['discoveredCheck', 'Discovered Check'],
    ['doubleCheck', 'Double Check'],
    ['deflection', 'Deflection'],
    ['attraction', 'Attraction'],
    ['capturingDefender', 'Capture the Defender'],
    ['intermezzo', 'Intermezzo'],
    ['hangingPiece', 'Hanging Piece'],
    ['backRankMate', 'Back Rank Mate'],
    ['anastasiaMate', "Anastasia's Mate"],
    ['operaMate', 'Opera Mate'],
    ['sacrifice', 'Sacrifice'],
    ['zugzwang', 'Zugzwang'],
    ['quietMove', 'Quiet Move'],
    ['defensiveMove', 'Defensive Move'],
    ['advancedPawn', 'Advanced Pawn'],
    ['exposedKing', 'Exposed King'],
    ['kingsideAttack', 'Kingside Attack'],
    ['queensideAttack', 'Queenside Attack']
];
export const PUZZLE_SETUP_FALLBACK_TEXT = 'Watch your opponent move.';
const DEFAULT_MISTAKE_FEEDBACK = 'That is not the move. Look again and try another idea.';
const nonEmpty = (text) => text?.trim() || undefined;
const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);
export const getVoiceText = (text, voice = DEFAULT_PUZZLE_VOICE) => nonEmpty(text?.[voice]);
const getTacticLabel = (puzzle) => TACTIC_LABELS.find(([theme]) => puzzle.themes.includes(theme))?.[1];
export const getPuzzleTheme = (puzzle) => getTacticLabel(puzzle) ?? (puzzle.goal === 'mate' ? 'Checkmate' : 'Win Material');
export const getPuzzleTitle = (puzzle) => puzzle.goal === 'mate' && puzzle.mateIn
    ? `Mate in ${puzzle.mateIn}`
    : (getTacticLabel(puzzle) ?? 'Win Material');
export const getPuzzleDescription = (puzzle) => {
    const intro = getVoiceText(puzzle.opponentMove.intro);
    if (intro)
        return intro;
    const side = capitalize(puzzle.sideToMove);
    if (puzzle.goal !== 'mate')
        return `${side} to play and win material.`;
    return puzzle.mateIn ? `${side} to play, mate in ${puzzle.mateIn}.` : `${side} to play and mate.`;
};
export const getNodePrompt = (puzzle, node) => getVoiceText(node.prompt) ??
    (puzzle.goal === 'mate' ? 'Find the checkmate.' : 'Find the best move.');
export const getYourMoveText = (puzzle, node, opponentComment) => {
    const prompt = getNodePrompt(puzzle, node);
    return opponentComment ? `${opponentComment} ${prompt}` : prompt;
};
export const getSolutionFeedback = (node) => getVoiceText(node.solution.feedback) ?? 'That is the move!';
export const getMistakeFeedback = (puzzle, mistake, voice = DEFAULT_PUZZLE_VOICE) => {
    const defaults = puzzle.mistakeDefaults[voice];
    return (getVoiceText(mistake?.feedback, voice) ??
        nonEmpty(mistake && defaults?.[mistake.kind]) ??
        nonEmpty(defaults?.any) ??
        DEFAULT_MISTAKE_FEEDBACK);
};
export const getSolutionPath = (root) => {
    const path = [];
    for (let node = root; node; node = node.solution.next)
        path.push(node);
    return path;
};
//# sourceMappingURL=index.js.map